import {
  BUSCAR_RELATORIO_ITINERARIOS,
  FILTRAR_RELATORIO_ITINERARIOS,
  LIMPAR_RELATORIO_ITINERARIOS
} from '../../actions/types'

const initialState = undefined;

export default function reducerRelatorioItinerarios (state = {}, action = initialState) {
  switch (action.type) {
    case BUSCAR_RELATORIO_ITINERARIOS: {
      return action.payload.data;
    }

    case FILTRAR_RELATORIO_ITINERARIOS: {
      return action.payload.resumo.filter(
          l => (l.nomeEmpresa.toLowerCase().includes(action.payload.texto.toLowerCase())) ||
              (l.rota.toLowerCase().includes(action.payload.texto.toLowerCase())) ||
              (l.prefixoRota && l.prefixoRota.toLowerCase().includes(action.payload.texto.toLowerCase())) ||
              (l.prestadorRota && l.prestadorRota.toLowerCase().includes(action.payload.texto.toLowerCase())) ||
              (l.veiculo && l.veiculo.toLowerCase().includes(action.payload.texto.toLowerCase())) ||
              (l.motoristas && l.motoristas.toLowerCase().includes(action.payload.texto.toLowerCase()))
      )
    }

    case LIMPAR_RELATORIO_ITINERARIOS:
      return [];


    default: {
      return state
    }
  }
}
